import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import fakeProjectData from '../../fakeData/fakeProjectData';
import MyReactWork from '../MyReactWork/MyReactWork';
import ProjectDetails from '../ProjectDetails/ProjectDetails';
import './Portfolioes.css';

const Portfolioes = () => {
    return (
        <div id="portfolio" className="">
            <div className="triangle"> 
            </div>
            <div className=" animate__animated animate__fadeInRight animate__delay-3s">
            <h2 className="text-center mt-5"><span>PORTFOLIO</span> MODULE</h2>
            <p className="text-center">Subtitle for portfolio module</p>
                <div className="separator text-center">
                    <span><FontAwesomeIcon icon={faCircle}/></span>
                </div>
            </div>
            <div className='container scrollbar'>
            <h2 className="text-center  animate__animated animate__fadeInUp animate__delay-2s">Developed by Wordpress</h2>
                <div className='row d-flex'>
                {fakeProjectData.map(project => (
                    <ProjectDetails key={project.id} project={project}/>
                ))}
                </div>
                    <MyReactWork/>
            </div>
       </div>
    );
};

export default Portfolioes;